import apiSlice from 'app/apiSlice';
import { uploadServiceEnv } from 'environment';

const appApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation({
      query: userInfo => ({
        url: 'session',
        method: 'POST',
        body: userInfo,
      }),
    }),

    logout: builder.mutation({
      query: () => ({
        url: 'session',
        method: 'DELETE',
      }),
    }),

    checkToken: builder.query({
      query: () => ({
        url: `accounts/me`,
      }),
    }),

    sendPasswordResetEmail: builder.mutation({
      query: payload => ({
        url: 'accounts/resetpw',
        method: 'POST',
        body: payload,
      }),
    }),

    verifyResetToken: builder.mutation({
      query: payload => ({
        url: 'accounts/resetpw/verify',
        method: 'POST',
        body: payload,
      }),
    }),

    changePassword: builder.mutation({
      query: payload => ({
        url: 'accounts/resetpw/change',
        method: 'POST',
        body: payload,
      }),
    }),

    uploadTemplate: builder.mutation({
      query: payload => ({
        url: `${uploadServiceEnv}/uploads`,
        method: 'POST',
        body: payload,
      }),
    }),

    sendUploadInformation: builder.mutation({
      query: uploadInformation => ({
        url: 'design_imports',
        method: 'POST',
        body: uploadInformation,
      }),
    }),

    getDesignStatus: builder.query({
      query: id => ({
        url: `design_imports/${id}`,
      }),
    }),

    resumeDesignImport: builder.mutation({
      query: id => ({
        url: `design_imports/${id}/resume`,
        method: 'PUT',
      }),
    }),
  }),
  overrideExisting: false, // Avoid overwriting existing endpoints
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useCheckTokenQuery,
  useSendPasswordResetEmailMutation,
  useVerifyResetTokenMutation,
  useChangePasswordMutation,
  useUploadTemplateMutation,
  useSendUploadInformationMutation,
  useLazyGetDesignStatusQuery,
  useResumeDesignImportMutation,
} = appApi;

export default appApi;
